/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/adminConnections.scss';

import React from 'react';
import Connection from "../../../models/connectionModel";
import classNames from 'classnames';
import {ConnectionStatus} from "../../../util/interfaces";
import IDate from '@dvrd/idate';

interface Props {
    connections: Connection[];
}

function getLastChanged(connection: Connection): string {
    const {statusChangedAtDate} = connection;
    if (!statusChangedAtDate) return 'n.v.t.';
    const now = IDate.now();
    const format = now.isAt(statusChangedAtDate, 'd') ? 'HH:mm' : 'DD-MM-YYYY HH:mm';
    return statusChangedAtDate.format(format);
}

export default function AdminConnections(props: Props) {
    const {connections} = props;

    function renderConnection(connection: Connection, index: number) {
        const statusMap: Record<ConnectionStatus, [string, string]> = {
            [ConnectionStatus.UP]: ['up', 'Up'],
            [ConnectionStatus.UNSTABLE]: ['unstable', 'Instabiel'],
            [ConnectionStatus.DOWN]: ['down', 'Down'],
        };
        const [status, title] = statusMap[connection.status];
        return (
            <div className={classNames('connection', status)} key={index}>
                <div className='connection-indicator' title={title}/>
                <span className='connection-label'>{connection.translatedName}</span>
                <label className='checked-label'>Laatst gewijzigd: {getLastChanged(connection)}</label>
            </div>
        )
    }

    return (
        <div className='connections-container'>
            <label className='connections-label'>Verbindingen</label>
            <div className='admin-connections'>
                {connections.map(renderConnection)}
            </div>
        </div>
    );
}